import { useEffect, useState } from "react";
import { api, imgUrl } from "@/lib/api";
import { Stars, TopRatedBadge, isTopRated } from "@/components/Stars";
import { REVIEW } from "@/constants/testIds";

const byline = (r) => [r.name, r.pet_name && `with ${r.pet_name}`].filter(Boolean).join(" ") || "Verified buyer";

export const ProductReviews = ({ slug }) => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/products/${slug}/reviews`).then(({ data }) => setData(data)).catch(() => setData(null)); }, [slug]);
  useEffect(() => {
    if (data?.count && window.location.hash.startsWith("#review-")) document.getElementById(window.location.hash.slice(1))?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [data]);
  if (!data?.count) return null;
  return (
    <section data-testid={REVIEW.productSection} className="mt-16">
      <div className="flex flex-wrap items-end gap-4">
        <h2 className="font-heading text-2xl font-bold">What pets think</h2>
        <div data-testid={REVIEW.productAverage} className="flex items-center gap-2 text-sm text-stone-600">
          <Stars value={data.average} /> {data.average} · {data.count} review{data.count === 1 ? "" : "s"}
          {isTopRated(data) && <TopRatedBadge testId={REVIEW.topRated} />}
        </div>
      </div>
      <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {data.reviews.map((r) => (
          <figure key={r.id} id={`review-${r.id}`} data-testid={REVIEW.productReview(r.id)} className="scroll-mt-28 bg-white border border-[#F0EBE1] rounded-[1.5rem] overflow-hidden">
            {r.photo && <img src={imgUrl(r.photo)} alt={r.pet_name ? `${r.pet_name} with the product` : "Customer's pet with the product"} loading="lazy" className="w-full aspect-square object-cover" />}
            <div className="p-4">
              <Stars value={r.rating} size={14} />
              {r.text && <blockquote className="mt-2 text-sm text-stone-700 leading-relaxed">{r.text}</blockquote>}
              <figcaption className="mt-3 text-xs text-stone-500">{byline(r)} · {new Date(r.created_at).toLocaleDateString()}</figcaption>
              {r.reply && (
                <div data-testid={REVIEW.reply(r.id)} className="mt-3 rounded-xl bg-[#FDFBF7] border border-[#F0EBE1] p-3 text-sm">
                  <p className="text-xs font-semibold text-[#E06D44]">Kiddee replied</p>
                  <p className="mt-1 text-stone-700">{r.reply}</p>
                </div>
              )}
            </div>
          </figure>
        ))}
      </div>
    </section>
  );
};
